<script lang="ts">
import { AppSidebarComponent } from "./app-sidebar.ts";
export default AppSidebarComponent;
</script>

<template>
    <p-sidebar
        :show-close-icon="true"
        position="right"
        v-bind="$attrs"
        class="app-sidebar"
    >
        <div class="app-sidebar-header" v-if="$slots.header">
            <slot name="header"></slot>
            <p-divider class="p-mb-1 p-mt-0" />
        </div>

        <p-scrollpanel class="app-sidebar-content">
            <slot />
        </p-scrollpanel>

        <div class="app-sidebar-footer" v-if="$slots.footer">
            <p-divider class="p-mt-1 p-mb-0" />
            <slot name="footer"></slot>
        </div>
    </p-sidebar>
</template>
